module.exports = __webpack_public_path__ + "static/media/wideOffice.4d86c5bd.jpg";